import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { Table } from "antd";
import DeleteShipmentModal from "./CreateShipments/DeleteModel";
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import { Button } from "@vds/buttons";
import { Checkbox } from "@vds/checkboxes";
import CustomModal from "../../components/CustomModal";
import {
  DropdownFilterWithCheckboxAndInitialValue,
  DropdownFilterWithDateRangePicker,
  DropdownFilterWithSearch,
  DropdownMultiFilterWithCheckboxAndInitialValue,
} from "../../components/DropdownFilter";

import {
  updateUI,
  updateBulkSelect,
  singleDeleteRequest,
  updatePaginationRequest,
  updateFilter,
} from "../../store/actions/shipment";

import ShipmentDropdown from "./ShipmentDropdown";
import ShipmentDropdownSingle from "./ShipmentDropdownSingle";
import CloneShipment from "./Clone/index";
import EditShipment from "./EditandClone";
import { Link } from "react-router-dom";
import UpdateStateShipment from "./UpdateStateShipment";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import CancelStateShipment from "./CancelStateShipment";
import DropdownFilterWithSearchInitialValue from "../../components/DropdownFilters/DropdownFilterWithSearchInitialValue";
import DropdownFilterWithDateRangePickerInitialValue from "../../components/DropdownFilters/DropdownFilterWithDateRangePickerInitialValue";

function ShipmentList() {
  const dispatch = useDispatch();
  dayjs.extend(utc);
  const {
    singleDeleteShipConfirmed,
    deletedField,
    selectedFields,
    isEditShipmentOpen,
    isCloneOpen,
  } = useSelector((state) => ({
    singleDeleteShipConfirmed: state.shipment.ui.delete.singleDelete,
    deletedField: state.shipment.ui.delete.deletedField,
    selectedFields: state.shipment.ui.selectedFields,
    selectedDeviceDetails: state.shipment.ui.selectedDeviceDetails,
    isEditShipmentOpen: state.shipment.ui.editShipment.isEditShipment,
    isCloneOpen: state.shipment.ui.clone.isClone,
  }));
const startDate = sessionStorage.getItem("startDate");
    const lastUpdated = sessionStorage.getItem("lastUpdated");
  const {
    isLoadingShipment,
    statusFilter,
    stateFilter,
    shipmentTitlesForFilter,
    shipmentTitlesForHighlight
  } = useSelector((state) => ({
    isLoadingShipment: state.shipment.isLoading.shipments,
    statusFilter: state.shipment.filters.status,
    stateFilter: state.shipment.filters.state,
    shipmentTitlesForFilter: state.shipment.shipmentTitlesForFilter,
    shipmentTitlesForHighlight: state.shipment.shipmentTitlesForHighlight
  }));
  const { shouldUpdate, count, currentPage, shipments, pageSize } = useSelector(
    (state) => ({
      shouldUpdate: state.shipment.shouldUpdate,
      count: state.shipment.data.count,
      shipments: state.shipment.data.shipments,
      currentPage: state.shipment.data.currentPage,
      pageSize: state.shipment.data.pageSize,
    })
  );

  const tableData =
    Array.isArray(shipments) && shipments.length > 0
      ? shipmentTitlesForFilter.length > 0
        ? shipments.filter((shipment) =>
            shipmentTitlesForFilter.includes(shipment.shipmentid)
          )
        : shipments
      : [];

  const handleMultipleChecked = (record, isChecked) => {
    if (isChecked) {
      dispatch(
        updateBulkSelect([
          ...selectedFields,
          {
            id: record.id,
            name: record.shipmentname,
            record,
          },
        ])
      );
    } else {
      const availableSelectedFields = selectedFields.filter(
        (selectedField) => selectedField.id !== record.id
      );
      dispatch(updateBulkSelect([...availableSelectedFields]));
    }
  };

  const handleShipmentNameFilterChange = (val) => {
    // dispatch(
    //   updateFilter({
    //     key: "shipmentid",
    //     value: {
    //       option: [],
    //       sort: "asc",
    //     },
    //   })
    // );
    sessionStorage.setItem("shipmentName", JSON.stringify(val))
    dispatch(
      updateFilter({
        key: "shipmentName",
        value: {
          option: val.filters.text === "" ? " " : val.filters.text,
          sort: val.isAsc ? "asc" : "desc",
        },
      })
    );
  };
  const handleShipmentNameFilterReset = () => {
    // dispatch(
    //   updateFilter({
    //     key: "shipmentid",
    //     value: {
    //       option: [],
    //       sort: "asc",
    //     },
    //   })
    // );
    sessionStorage.removeItem("shipmentName")
    dispatch(
      updateFilter({
        key: "shipmentName",
        value: {
          option: " ",
          sort: "asc",
        },
      })
    );
  };
  const handleStatusFilterChange = (filter) => {
    // dispatch(
    //   updateFilter({
    //     key: "shipmentid",
    //     value: {
    //       option: [],
    //       sort: "asc",
    //     },
    //   })
    // );
    const filterArr = Object.entries(filter.filters);

    if (filterArr.length === 0) {
      return;
    }

    const filterValue = filterArr.map((filter) => ({
      text: filter[0],
      value: filter[1],
    }));
    // we are setting the selected statefiltervalues in a session
    sessionStorage.setItem("status", JSON.stringify(filterValue));
    dispatch(
      updateFilter({
        key: "status",
        value: {
          option: filterValue,
          sort: "",
        },
      })
    );
  };
  const handleStatusFilterReset = (filter) => {
    // dispatch(
    //   updateFilter({
    //     key: "shipmentid",
    //     value: {
    //       option: [],
    //       sort: "asc",
    //     },
    //   })
    // );
    // we are removing the selected statefiltervalues in a session
    sessionStorage.removeItem("status");
    dispatch(
      updateFilter({
        key: "status",
        value: {
          option: [
            {
              text: "Active",
              value: "header",
            },
            {
              text: "No Alert",
              value: false,
            },
            {
              text: "Warning",
              value: false,
            },
            {
              text: "Critical",
              value: false,
            },
            {
              text: "Notification",
              value: false,
            },
            {
              text: "Inactive",
              value: "header",
            },
            {
              text: "Completed",
              value: false,
            },
          ],
          sort: "",
        },
      })
    );
  };
  const handleLastUpdatedFilterChange = (filter) => {
    // dispatch(
    //   updateFilter({
    //     key: "shipmentid",
    //     value: {
    //       option: [],
    //       sort: "asc",
    //     },
    //   })
    // );
    sessionStorage.setItem("lastUpdated", JSON.stringify(filter))
    dispatch(
      updateFilter({
        key: "lastUpdated",
        value: {
          option: {
            lastupdatedfrom: filter.filters.text[0],
            lastupdatedto: dayjs(filter.filters.text[1])
              .set("hour", 23)
              .set("minute", 59)
              .set("second", 59),
          },
          sort: filter.isAsc ? "asc" : "desc",
        },
      })
    );
  };
  const handleLastUpdatedFilterReset = () => {
    // dispatch(
    //   updateFilter({
    //     key: "shipmentid",
    //     value: {
    //       option: [],
    //       sort: "asc",
    //     },
    //   })
    // );
    sessionStorage.removeItem("lastUpdated")
    dispatch(
      updateFilter({
        key: "lastUpdated",
        value: {
          option: {
            lastupdatedfrom: "",
            lastupdatedto: "",
          },
          sort: "asc",
        },
      })
    );
  };
  const handleStartDateFilterChange = (filter) => {
    // dispatch(
    //   updateFilter({
    //     key: "shipmentid",
    //     value: {
    //       option: [],
    //       sort: "asc",
    //     },
    //   })
    // );
    sessionStorage.setItem("startDate", JSON.stringify(filter))
    dispatch(
      updateFilter({
        key: "startDate",
        value: {
          option: {
            startdatefrom: filter.filters.text[0],
            startdateto: dayjs(filter.filters.text[1])
              .set("hour", 23)
              .set("minute", 59)
              .set("second", 59),
          },
          sort: filter.isAsc ? "asc" : "desc",
        },
      })
    );
  };
  const handleStartDateFilterReset = () => {
    // dispatch(
    //   updateFilter({
    //     key: "shipmentid",
    //     value: {
    //       option: [],
    //       sort: "asc",
    //     },
    //   })
    // );
    sessionStorage.removeItem("startDate")
    dispatch(
      updateFilter({
        key: "startDate",
        value: {
          option: {
            startdatefrom: "",
            startdateto: "",
          },
          sort: "asc",
        },
      })
    );
  };
  const handleStateFilterChange = (filter) => {
    // dispatch(
    //   updateFilter({
    //     key: "shipmentid",
    //     value: {
    //       option: [],
    //       sort: "asc",
    //     },
    //   })
    // );
    const filterArr = Object.entries(filter.filters);

    if (filterArr.length === 0) {
      return;
    }

    const filterValue = filterArr.map((filter) => ({
      text: filter[0],
      value: filter[1],
    }));
    // we are setting the selected statefiltervalues in a session
    sessionStorage.setItem("state", JSON.stringify(filterValue));
    dispatch(
      updateFilter({
        key: "state",
        value: {
          option: filterValue,
          sort: "",
        },
      })
    );
  };

  const handleStateFilterReset = () => {
    // dispatch(
    //   updateFilter({
    //     key: "shipmentid",
    //     value: {
    //       option: [],
    //       sort: "asc",
    //     },
    //   })
    // );
    // we are removing the selected statefiltervalues in a session
    sessionStorage.removeItem("state");
    dispatch(
      updateFilter({
        key: "state",
        value: {
          option: [
            {
              text: "In Progress",
              value: true,
            },
            {
              text: "Scheduled",
              value: true,
            },
            {
              text: "Completed",
              value: false,
            },
            {
              text: "Cancelled",
              value: false,
            },
          ],
          sort: "",
        },
      })
    );
  };
  const columns = [
    {
      title: (
        <DropdownMultiFilterWithCheckboxAndInitialValue
          text="Status"
          isSortable={false}
          onApply={handleStatusFilterChange}
          onReset={handleStatusFilterReset}
          menuItems={statusFilter.option}
        />
      ),
      dataIndex: "status",
      key: "status",
      onHeaderCell: () => ({
        "data-tooltip": "",
      }),
      render: (text, record) => {
        let isChecked = false;
        if (
          Array.isArray(selectedFields) &&
          selectedFields.filter((field) => field.id === record.id).length > 0
        ) {
          isChecked = true;
        }
        return (
          <div className="d-flex flex-row justify-content-start align-items-center">
            <div>
              <Checkbox
                id={record.id}
                selected={isChecked}
                onChange={(e) =>
                  handleMultipleChecked(record, e.target.checked)
                }
                className="me-3"
              />
            </div>
            {text !== null || text !== undefined ? (
              <div
                className={`status-${text?.toLowerCase().replaceAll(" ", "-")}`}
              ></div>
            ) : (
              <div className="status-notification"></div>
            )}
          </div>
        );
      },
    },
    {
      title: (
        <DropdownFilterWithSearchInitialValue
          text="Shipment name"
          isSortable={true}
          onApply={handleShipmentNameFilterChange}
          onReset={handleShipmentNameFilterReset}
        />
      ),
      dataIndex: "shipmentName",
      key: "shipmentName",
      onHeaderCell: () => ({
        "data-tooltip": "",
      }),
      render: (text, record) => {
        return (
          <Link
            className="shipment-text-link"
            to={`/viewshipment/${record.shipmentid}`}
            state={{
              alert: "map",
              id: record.id,
              deviceid: record.deviceid,
              gateway: record?.deviceType?.startsWith("A"),
              shipmentData: {
                shipmentid: record.shipmentid,
                shipmentname: record.shipmentName,
                //deviceid: record.deviceId,
                updatedat: record.lastUpdated,
                origin: record.origin,
                destination: record.destination,
                //devicetype: record.deviceType,
                startdate: record.startDate,
                completiondate: record.completionDate,
                deviceprofile: record.deviceProfile,
                //oncompletion: record.profileUponCompletion,
                devicename: record.deviceName,
                devicetype: record.devicetype,
                oncompletion: record.oncompletion,
                deviceid: record.deviceid,
                startDateOriginal: record.startDateOriginal,
              },
            }}
          >
            {text}
          </Link>
        );
      },
    },
    {
      title: (
        <DropdownFilterWithCheckboxAndInitialValue
          text="State"
          isSortable={false}
          onApply={handleStateFilterChange}
          onReset={handleStateFilterReset}
          menuItems={stateFilter.option}
        />
      ),
      dataIndex: "state",
      className: "state",
      render: (text) => <span>{text}</span>,
      key: "state",
    },
    
    {
      title: (
        <DropdownFilterWithDateRangePickerInitialValue
          text="Start date"
          isSortable={true}
          onApply={handleStartDateFilterChange}
          onReset={handleStartDateFilterReset}
          value={JSON.parse(startDate)}
        />
      ),
      dataIndex: "startDate",
      key: "startDate",
      onHeaderCell: () => ({
        "data-tooltip": "",
      }),
      render: (text, record) => {
        return (
          <span>
            {text
              ? dayjs(text).format("MM-DD-YY [at] HH:mm:ss").toLowerCase()
              : null}
          </span>
        );
      },
    },
    {
      title: (
        <DropdownFilterWithDateRangePickerInitialValue
          text="Last updated"
          isSortable={true}
          onApply={handleLastUpdatedFilterChange}
          onReset={handleLastUpdatedFilterReset}
          value={JSON.parse(lastUpdated)}
        />
      ),
      dataIndex: "lastUpdated",
      key: "lastUpdated",
      onHeaderCell: (column) => ({
        "data-tooltip": "",
      }),
      render: (text, record) => <div>{text}</div>,
    },
    {
      title: <ShipmentDropdown />,
      render: (text, record) => {
        return (
          <ShipmentDropdownSingle name={text} id={record.id} record={record} />
        );
      },
      dataIndex: "action",
    },
  ];

  const handleDelete = () => {};

  const onExit = () => {
    dispatch(
      updateUI({
        key: "delete",
        value: {
          singleDelete: !singleDeleteShipConfirmed,
          deletedField: {
            id: "",
            name: "",
          },
        },
      })
    );
  };

  const onConfirm = () => {
    dispatch(
      singleDeleteRequest({
        singleDelete: false,
      })
    );
  };
  const rowhighlightBasedOnHoverOnShipmentPoint = (record) => {
    return shipmentTitlesForHighlight.includes(record?.shipmentid)
      ? "highlight-hover"
      : "";
  };

  return (
    <div className="shipment-list-view-container">
      <Table
        loading={isLoadingShipment}
        rowKey="shipment-row-key"
        columns={columns}
        dataSource={tableData}
        pagination={{
          current: currentPage,
          pageSize: pageSize,
          pageSizeOptions: ["10", "20", "50", "100"],
          total: count,
          showTotal: (total, range) =>
            `Showing ${range[0]} - ${range[1]} of ${total}`,
          position: ["bottomRight"],
          prevIcon: ["Previous"],
          nextIcon: ["Next"],
          onChange: (page, pageSize) => {
            dispatch(
              updatePaginationRequest({
                data: { pageSize: pageSize, currentPage: page },
                shouldUpdate: !shouldUpdate,
              })
            );
          },
          showSizeChanger: true,
          locale: {
            items_per_page: "",
          },
        }}
        rowClassName={rowhighlightBasedOnHoverOnShipmentPoint}
      />
      <CustomModal
        modalKey={"shipment"}
        popupName={""}
        customClass={"deleteAlertGroup"}
        popupTitle={"Delete shipment"}
        open={singleDeleteShipConfirmed}
      >
        <>
          <p style={{ padding: "5px", marginTop: "25px", paddingLeft: "0px" }}>
            <>
              <span>Are you sure you'd like to delete the Shipment </span>
              <span
                style={{
                  fontWeight: "700",
                  fontFamily: "VerizonNHGDSBold",
                  fontSize: "16px",
                }}
              >
                {deletedField?.name || ""}?
              </span>{" "}
              <br />
              <span>
                Deleting this shipment, will permanently remove the data of the
                shipment.{" "}
              </span>
            </>
          </p>
          <Grid2
            container
            marginTop={1}
            marginBottom={0}
            spacing={1}
            columns={{ xs: 12 }}
          >
            <Grid2 item xs={12} sm={6} md={6} lg={6}>
              <div className="mb-3">
                <Button
                  className="custom-button-cancel"
                  type="default"
                  shape="round"
                  style={{
                    fontWeight: "bold",
                    width: "100%",
                    backgroundColor: "white",
                    color: "black",
                  }}
                  onClick={() => onExit()}
                  size={"large"}
                >
                  No, cancel
                </Button>
              </div>
            </Grid2>
            <Grid2 item xs={12} sm={6} md={6} lg={6}>
              <div className="mb-3">
                <Button
                  className="custom-button-save"
                  type="primary"
                  shape="round"
                  onClick={() => {
                    onConfirm();
                  }}
                  style={{ fontWeight: "bold", width: "100%" }}
                  size={"large"}
                >
                  Yes, delete
                </Button>
              </div>
            </Grid2>
          </Grid2>
        </>
      </CustomModal>
      {isCloneOpen === true ? <CloneShipment visible={isCloneOpen} /> : ""}
      <UpdateStateShipment />
      <CancelStateShipment />
      {isEditShipmentOpen === true ? (
        <EditShipment
          visible={isEditShipmentOpen}
          // state={isEditRecord}
          //  editRecord={isEditRecord}
        />
      ) : (
        ""
      )}
    </div>
  );
}

export default ShipmentList;
